import { getFetchWrapper } from "@syf-api-library/core";
import { personalizedCardArtUrl } from "../endpoints.js";
const queryFnFactory = (config, keyProps) => {
  return () => {
    const fetchWrapper = getFetchWrapper(config);
    const params = new URLSearchParams({
      "cipher.accountId": keyProps.accountId
    });
    if (keyProps.accountIdType) {
      params.set("accountIdType", keyProps.accountIdType);
    }
    return fetchWrapper(`${personalizedCardArtUrl}?${params}`, {
      method: "GET"
    });
  };
};
export {
  queryFnFactory as default
};
//# sourceMappingURL=query.js.map
